import React from 'react';
import {List, ListItemIcon, ListItemText, ListItemButton, Box} from '@mui/material';
import { PermissionsProvider, usePermissions } from './PermissionsContext';
import Icon from './Icon';
import {
    InsertLink,
    AccountCircleOutlined,
    GroupOutlined,
    PlaylistPlayOutlined,
    RocketOutlined,
    VideoLibraryOutlined,
    CategoryOutlined,
    TvOutlined,
    SportsVolleyballOutlined,
    HomeMiniOutlined,
    HomeOutlined,
    TrendingFlat,
    Domain,
    WebAssetOutlined,
    MonetizationOnOutlined,
    MoneyOffCsredOutlined,
    MoneyRounded,
    ViewListOutlined,
    ViewStream,
    ViewTimeline,
    ViewTimelineOutlined, WorkHistoryOutlined, YardOutlined
} from '@mui/icons-material';
import { NavLink } from 'react-router-dom';


interface SidebarProps {
    onLogoClick: () => void;
    onCloseMenuClick: () => void;
}


const Sidebar: React.FC<SidebarProps> = ({onLogoClick, onCloseMenuClick}) => {
    const { permissions } = usePermissions();

    return (
        <List>
            <Box className='menuLogo' onClick={onLogoClick}>
                <img src="/horisontalLogo.svg" className='horisontalLogo' alt=""/>
            </Box>
            <ListItemButton onClick={onCloseMenuClick} component={NavLink} to="/" end>
                <ListItemIcon><Icon name="home" /></ListItemIcon>
                <ListItemText primary="Главная" />
            </ListItemButton>
            {permissions?.can_read_products && (
                <ListItemButton onClick={onCloseMenuClick} component={NavLink} to="/products">
                    <ListItemIcon><Icon name="products" /></ListItemIcon>
                    <ListItemText primary="Продукты" />
                </ListItemButton>
            )}
            {permissions?.can_read_projects && (
                <ListItemButton onClick={onCloseMenuClick} component={NavLink} to="/presentations">
                    <ListItemIcon><Icon name="presentations" /></ListItemIcon>
                    <ListItemText primary="Презентации" />
                </ListItemButton>
            )}
            {permissions?.can_read_projects && (
                <ListItemButton onClick={onCloseMenuClick} component={NavLink} to="/scenarios">
                    <ListItemIcon><Icon name="scenarios" /></ListItemIcon>
                    <ListItemText primary="Сценарии" />
                </ListItemButton>
            )}
            {permissions?.can_read_projects && (
                <ListItemButton onClick={onCloseMenuClick} component={NavLink} to="/video">
                    <ListItemIcon><Icon name="video" /></ListItemIcon>
                    <ListItemText primary="Видео" />
                </ListItemButton>
            )}
            {permissions?.can_read_projects && (
                <ListItemButton onClick={onCloseMenuClick} component={NavLink} to="/audio">
                    <ListItemIcon><Icon name="audio" /></ListItemIcon>
                    <ListItemText primary="Аудио" />
                </ListItemButton>
            )}
            {permissions?.can_read_projects && (
                <ListItemButton onClick={onCloseMenuClick} component={NavLink} to="/instructions">
                    <ListItemIcon><Icon name="documents" /></ListItemIcon>
                    <ListItemText primary="Инструкции" />
                </ListItemButton>
            )}
            {permissions?.can_read_projects && (
                <ListItemButton onClick={onCloseMenuClick} component={NavLink} to="/statistics">
                    <ListItemIcon><Icon name="stat" /></ListItemIcon>
                    <ListItemText primary="Статистика" />
                </ListItemButton>
            )}
            {/*{permissions?.can_create_users && (*/}
            <ListItemButton onClick={onCloseMenuClick} component={NavLink} to="/team">
                <ListItemIcon><Icon name="team" /></ListItemIcon>
                <ListItemText primary="Команда" />
            </ListItemButton>
            {/*)}*/}
            <ListItemButton onClick={onCloseMenuClick} component={NavLink} to="/profile">
                <ListItemIcon><Icon name="profile" /></ListItemIcon>
                <ListItemText primary="Профиль" />
            </ListItemButton>
        </List>
    );
};

export default Sidebar;